/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Sinp_Bags_Err_InvalidInputs */

const vi_sinp_bags_err_invalid = /** @type {(inputs: Sinp_Bags_Err_InvalidInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Số bao phải là số nguyên lớn hơn 0.`)
};

/**

* @param {Sinp_Bags_Err_InvalidInputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
export const sinp_bags_err_invalid = /** @type {((inputs?: Sinp_Bags_Err_InvalidInputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Sinp_Bags_Err_InvalidInputs, { locale?: "vi" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_sinp_bags_err_invalid(inputs)
});